export default __webpack_public_path__ + "static/media/Snd_TryP.eda94cbc.mp3";